import {Component, Input, OnInit} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {RulesService} from '../../rules.service';
import {MailActionModel} from '../../model/mail.action.model';
import {Constants} from '../../constants';
import {IActionConfiguration} from '../../model/action.configuration.interface';
import {AxisValueOptions} from 'highcharts';

@Component({
  selector: 'app-mail',
  templateUrl: './mail.component.html',
  styleUrls: ['./mail.component.scss']
})
export class MailComponent implements OnInit {
  subject: FormControl;
  content: FormControl;
  mailList = [];
  ccMailList = [];
  submitted: boolean;
  @Input() action: IActionConfiguration;
  constructor(private ruleService: RulesService) { }

  ngOnInit() {
    this.initFormControl();
  }

  initFormControl() {
    let content, subject;
    if (this.action) {
      content = this.action.configuration.content;
      subject = this.action.configuration.subject;
      this.mailList = this.action.configuration.to.split(',');
      if (this.action.configuration.cc) {
        this.ccMailList = this.action.configuration.cc.split(',');
      }
      }

    this.content = new FormControl(content, [Validators.required, Validators.maxLength(250)]);
    this.subject = new FormControl(subject, [Validators.required, Validators.maxLength(50)]);
  }
  addPrimaryEmail(email: string) {
      if (!this.mailList.find(item => item === email)) {
        this.mailList.push(email);
      }
      return false;
    }

  removePrimaryMail(email: string) {
    email = email ? email : this.mailList[this.mailList.length - 1];
    this.remove(email, this.mailList);
  }

  addCCEmail(email: string) {
   if (!this.ccMailList.find(item => item === email)) {
        this.ccMailList.push(email);
      }
      return false;
  }

  removeCCMail(email: string) {
    email = email ? email : this.ccMailList[this.ccMailList.length - 1];
    this.remove(email, this.ccMailList);
  }

  remove(email, itemArray) {
    const index = itemArray.indexOf(email);
    if (index !== -1) {
      itemArray.splice(index, 1);
    }
  }

  next() {
    this.submitted = true;
    if (this.isValidState()) {
      let action: MailActionModel = new MailActionModel();
      action.name = Constants.MAIL_ACTION;
      action.configuration.to = this.mailList.join(Constants.COMMA);
      action.configuration.cc = this.ccMailList.join(Constants.COMMA);
      action.configuration.subject = this.subject.value;
      action.configuration.content = this.content.value;
      this.ruleService.saveAction(action);
      this.ruleService.goToNextAction();
    }
  }
  back() {
    this.ruleService.goToPreviousAction();
  }

  private isValidState(): boolean {
    if (!this.mailList.length) {
      return false;
    }
    if (!this.subject.valid) {
      return false;
    }
    if (!this.content.valid) {
      return false;
    }
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/rules/output/mail/mail.component.ts